module.exports = __webpack_public_path__ + "static/media/1971287250_20190214_143805_3734875_resized.9fc8edcb.JPG";